import { apiClient } from "@config/apiClient";
import { API_URL } from "@config/constants";
import { IPagedResponse } from "@interfaces/responses.interface";
import { ISourcingSettings, IThemeOption } from "@interfaces/sourcing.interface";

class SourcingService {
  private URL = `${API_URL}/sourcing`;

  async searchSourcingThemes(params: URLSearchParams): Promise<IPagedResponse<IThemeOption>> {
    return apiClient.get(`${this.URL}/themes/search/?${params.toString()}`);
  }

  async getSourcingThemes(params: URLSearchParams): Promise<IPagedResponse<IThemeOption>> {
    return apiClient.get(`${this.URL}/themes/?${params.toString()}`);
  }

  async getSourcingThemesTree(parentId: string, query?: string): Promise<ISourcingSettings> {
    const params = query ? `?query=${encodeURIComponent(query)}` : "";
    return apiClient.get(`${this.URL}/themes/${parentId}/tree/${params}`);
  }

  async getSourcingSettings(): Promise<ISourcingSettings> {
    return apiClient.get(`${this.URL}/settings/obtain/`);
  }
}

const sourcingService = new SourcingService();
export default sourcingService;
